import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import { TypeService } from '@thewhite/react-global-module/lib/services';

export enum UserAuthoritiesTypes {
    ADMIN = 'ADMIN',
    OPERATOR = 'OPERATOR',
    PARTNER = 'PARTNER',
    USER = 'USER',
    SOCIAL_REGISTRY_OPERATOR = 'SOCIAL_REGISTRY_OPERATOR',
    ECOFORUM_PARTNER = 'ECOFORUM_PARTNER',
    VEHICLE = 'VEHICLE',
}

interface IUserAuthorities {
    [value: string]: SimpleObjectInterface;

    ADMIN: SimpleObjectInterface;
    OPERATOR: SimpleObjectInterface;
    PARTNER: SimpleObjectInterface;
    USER: SimpleObjectInterface;
    SOCIAL_REGISTRY_OPERATOR: SimpleObjectInterface;
    ECOFORUM_PARTNER: SimpleObjectInterface;
    VEHICLE: SimpleObjectInterface;
}

const USER_AUTHORITIES: IUserAuthorities = {
    ADMIN: {
        name: 'Администратор',
        value: 'ADMIN',
    },
    OPERATOR: {
        name: 'Оператор',
        value: 'OPERATOR',
    },
    PARTNER: {
        name: 'Партнер',
        value: 'PARTNER',
    },
    USER: {
        name: 'Пользователь',
        value: 'USER',
    },
    SOCIAL_REGISTRY_OPERATOR: {
        name: 'Оператор реестра льготников',
        value: 'SOCIAL_REGISTRY_OPERATOR',
    },
    ECOFORUM_PARTNER: {
        name: 'Партнёр Экофорума',
        value: 'ECOFORUM_PARTNER',
    },
    VEHICLE: {
        name: 'Транспорт',
        value: 'VEHICLE',
    },
};

export default USER_AUTHORITIES;

export const DocumentKindEnumType = TypeService.createEnum<UserAuthoritiesTypes>(UserAuthoritiesTypes, 'UserAuthoritiesTypes');
